import { ReactNode } from "react";

import { ChevronDown } from "components/icons/generated";
import Button from "ds/components/Button";
import DropdownMenu from "ds/components/DropdownMenu";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";

export type PermissionBasedDropdownItem = {
  id: string;
  label: ReactNode;
  onAction: () => void;
  canPerformAction: {
    result: boolean;
    message?: string;
  };
  hidden?: boolean;
};

type PermissionBasedDropdownProps = {
  buttonLabel: string;
  items: PermissionBasedDropdownItem[];
};

const PermissionBasedDropdown = ({ buttonLabel, items }: PermissionBasedDropdownProps) => {
  // Filter out hidden items
  const visibleItems = items.filter((item) => !item.hidden);

  // Check if at least one item is available
  const hasAnyPermission = visibleItems.some((item) => item.canPerformAction.result);
  if (!hasAnyPermission) return null;

  return (
    <DropdownMenu
      triggerComponent={
        <Button variant="primary" endIcon={ChevronDown}>
          {buttonLabel}
        </Button>
      }
    >
      {visibleItems.map((item) => (
        <DropdownMenuItem
          key={item.id}
          onAction={item.onAction}
          isDisabled={!item.canPerformAction.result}
          tooltip={item.canPerformAction.message}
        >
          {item.label}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};

export default PermissionBasedDropdown;
